import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer-wrap">
    <div className="footer-inner">
      <div className="footer-info">
        <h2>Sanoma Games</h2>
        <p>
          Viihdyttävää viestintää vuodesta 2007 
        </p>
      </div>
      <div className="footer-contact">
        <p>
          <strong>Yhteystiedot</strong>
          <br />
          Töölönlahdenkatu 2, PL 65
          <br />
          00089 Sanoma
          <br />
          <Link to="/ota-yhteytta">Ota yhteyttä</Link>
        </p>
      </div>
      <small className="copyright">
        <span id="year">{new Date().getFullYear()}</span> © Sanoma Games
        <br />
        <a href="rekisteriseloste.html">Rekisteriseloste</a>&nbsp;&nbsp;<a href="https://www.sanoma.fi/tietosuojalauseke/">Tietosuojalauseke</a>
      </small>
    </div>
    { /*<Map /> */}
  </footer>
);

export default Footer;
